import React from "react";


const AiInsightsRefresh = ({ lastGeneratedTime, handleClick, isDisable }) => {
  const month = String(lastGeneratedTime.getMonth() + 1).padStart(2, '0');
  const day = String(lastGeneratedTime.getDate()).padStart(2, '0');
  const year = lastGeneratedTime.getFullYear();

  let hours = lastGeneratedTime.getHours();
  const minutes = String(lastGeneratedTime.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  const timeStr = `${hours}:${minutes}${ampm}`;

  return (
    <div className="refresh">
      <span style={{ fontSize: "14px" }} className="last-updated-text">
        Last updated on {month}/{day}/{year} at {timeStr}
      </span>
      <AiInsightsRefreshIcon
        className={isDisable ? "refresh-icon disable" : "refresh-icon"}
        onClick={!isDisable ? () => handleClick() : null}
      />
    </div>
  );
};


export default AiInsightsRefresh;


const AiInsightsRefreshIcon = (props) => (
  <svg
    fill="#000000"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 367.136 367.136"
    xmlSpace="preserve"
    {...props}
  >
    <path
      d="M336.954,87.494C318.821,59.1,293.251,36.318,263.01,21.613l-13.119,26.979c52.77,25.661,85.551,78.029,85.551,136.669
	c0,83.744-68.131,151.874-151.874,151.874S31.694,269.005,31.694,185.262c0-49.847,24.899-96.439,65.042-124.571L149.7,113.91V0
	H36.335l38.953,39.14C57.727,52.164,42.557,68.287,30.582,86.871c-18.898,29.33-28.888,63.352-28.888,98.391
	c0,100.286,81.588,181.874,181.874,181.874s181.874-81.588,181.874-181.874C365.442,150.485,355.59,116.678,336.954,87.494z"
    />
  </svg>
);
